<template>
  <div class="d-flex justify-end" :class="$root.isMobile ? 'flex-column' : ''">
    <!-- Close Button (Always visible) -->
    <v-btn
      depressed
      tile
      outlined
      color="primary"
      :class="$root.isMobile ? 'mt-3' : 'ml-3'"
      :width="$root.isMobile ? '100%' : '140px'"
      @click="$router.push('/')"
    >
      Close
    </v-btn>

    <!-- Create Mode Buttons -->
    <template v-if="isCreate">
      <v-btn
        tile
        depressed
        class="primary"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
        @click="$emit('addRecord', false)"
      >
        Save Estimate
      </v-btn>
    </template>

    <!-- Update Mode Buttons -->
    <template v-else>

      <v-btn
        v-if="isEstimateGet"
        tile
        depressed
        class="primary"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
        @click="bookJob"
      >
        Book Job
      </v-btn>

      <v-btn
        v-if="isEstimateGet"
        tile
        depressed
        class="error"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
        @click="remove()"
      >
        Delete
      </v-btn>
      
      <v-btn
        tile
        depressed
        class="success"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
        @click="$emit('updateEstimate')"
      >
        Update
      </v-btn>
    </template>
  </div>
</template>

<script>
import customerMixins from "../../../assets/js/customer.mixins";
import { estimate } from "../../../assets/js/firebase";

export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [customerMixins],
  computed: {
    // Force isCreate based on route
    isCreate() {
      return this.$route.name === 'estimate-create' || !this.$route.params.id;
    },
    isEstimateGet() {
      return this.$route.name === 'estimate-get';
    },
    isDelete() {
      // Allow delete for estimates in draft status
      let { status } = this.item;
      return status == 0 || status == undefined;
    },
  },
  methods: {

    bookJob() {
      // Redirect to customer create with estimate data
      this.$router.push({
        path: '/customers/create',
        query: {
          estimateId: this.item.id,
          template: this.item.template,
          autofill: 'true'
        }
      });
    },
    async remove() {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure you want to delete this estimate?",
        onConfirm: async () => {
          let { params } = vm.$route;
          let { id } = params;
          try {
            vm.$root.loader = true;
            // Use estimate collection instead of customers
            await estimate.doc(id).delete();
            vm.$root.loader = false;
            vm.$alert.show("Estimate deleted successfully");
            vm.$router.push('/manage-estimate');
          } catch (error) {
            vm.$root.loader = false;
            vm.$alert.show(error.message);
          }
        },
      });
    },
  },
};
</script>

<style></style>
